<template>
  <div class="text-center">
    <v-dialog
      max-width="700px"
      style="z-index: 9999"
      v-model="dialog"
      transition="dialog-bottom-transition"
      overlay-opacity="0.9"
      overlay-color="black">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon large v-bind="attrs" v-on="on">
          <v-icon color="white">mdi-palm-tree</v-icon>
        </v-btn>
      </template>

      <v-card class="rounded-xl" color="#1E1E1E">
        <v-toolbar flat color="transparent" class="pt-2 pb-2">
          <v-toolbar-title class="text-h6 font-weight-bold white--text pl-2"> Ferienplanung </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" color="grey"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pb-0">
          <v-card class="rounded-lg pa-4 gradient-dark border-light" elevation="0">
            <div class="d-flex justify-space-between align-center">
              <div>
                <div class="text-caption grey--text mb-1">RESTSALDO (TAGE)</div>
                <div class="text-h4 font-weight-bold white--text">
                  {{ Math.round(vacations.days * 100) / 100 }}
                </div>
              </div>
              <div class="text-right">
                <div class="text-caption grey--text mb-1">STUNDEN</div>
                <div class="text-h5 font-weight-medium grey--text">
                  {{ Math.round(vacations.hours * 10) / 10 }}
                </div>
              </div>
            </div>
          </v-card>
        </v-card-text>

        <v-card-text class="pa-0 mt-2">
          <v-tabs v-model="tab" background-color="transparent" grow slider-color="#00963f" centered>
            <v-tab class="font-weight-bold text-caption white--text">Meine Anträge</v-tab>
            <v-tab class="font-weight-bold text-caption white--text">Neuer Antrag</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" class="transparent-bg mt-4" touchless>
            <v-tab-item>
              <div v-if="sortedHolidayEntries.length === 0" class="pa-10 text-center">
                <v-icon size="64" color="#333" class="mb-4">mdi-island</v-icon>
                <div class="grey--text">Keine Ferieneinträge gefunden.</div>
              </div>

              <v-list v-else two-line color="transparent" class="px-2 pb-4" style="max-height: 400px; overflow-y: auto">
                <v-card v-for="entry of sortedHolidayEntries" :key="entry._id" class="mb-3 rounded-lg border-light" color="#252525" elevation="0">
                  <div class="d-flex align-center pa-3">
                    <v-icon color="#00963f" class="mr-3 ml-1">mdi-calendar-range</v-icon>
                    <div class="flex-grow-1">
                      <div class="text-subtitle-2 white--text">
                        {{ $moment(entry.dates[0].date).format("DD.MM.") }} -
                        {{ $moment(entry.dates[entry.dates.length - 1].date).format("DD.MM.YY") }}
                      </div>
                      <div class="text-caption grey--text">
                        {{ Math.round(entry.duration * 100) / 100 }} Tage ({{ entry.subtractedDays }} abgezogen)
                      </div>
                    </div>
                    <v-chip
                      small
                      label
                      :color="entry.status === 'open' ? 'orange' : entry.status === 'accepted' ? '#00963f' : 'red'"
                      text-color="white"
                      class="font-weight-bold mr-2">
                      {{ mapHolidayStatus[entry.status] }}
                    </v-chip>
                    <v-btn icon small v-if="entry.status === 'open'" @click="selfCancelHoliday(entry._id)" color="grey darken-1">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </v-list>
            </v-tab-item>

            <v-tab-item>
              <v-stepper v-model="stepperModel" vertical class="transparent elevation-0 pb-4">
                <v-stepper-step :complete="stepperModel > 1" step="1" color="#00963f">
                  <span class="white--text">Startdatum</span>
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-date-picker
                    v-model="startDate"
                    no-title
                    scrollable
                    color="#00963f"
                    full-width
                    dark
                    class="rounded-lg elevation-0 mb-4"></v-date-picker>
                  <v-btn color="#00963f" depressed class="rounded-lg white--text" :disabled="!startDate" @click="stepperModel = 2">Weiter</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="stepperModel > 2" step="2" color="#00963f">
                  <span class="white--text">Enddatum</span>
                </v-stepper-step>
                <v-stepper-content step="2">
                  <v-date-picker
                    v-model="endDate"
                    :min="startDate"
                    no-title
                    scrollable
                    color="#00963f"
                    full-width
                    dark
                    class="rounded-lg elevation-0 mb-4"></v-date-picker>

                  <div class="d-flex">
                    <v-btn text color="grey" @click="stepperModel -= 1">Zurück</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="#00963f" depressed class="rounded-lg white--text" :disabled="!endDate" @click="calculateDates()">Berechnen</v-btn>
                  </div>
                </v-stepper-content>

                <v-stepper-step :complete="stepperModel > 3" step="3" color="#00963f">
                  <span class="white--text">Tage anpassen & Senden</span>
                </v-stepper-step>
                <v-stepper-content step="3">
                  <div style="overflow: auto" class="text-subtitle-2 white--text mb-2 pl-1">Tage im Detail</div>
                  <v-card color="#252525" class="rounded-lg mb-4 border-light overflow-hidden" elevation="0">
                    <div style="max-height: 250px; overflow-y: auto">
                      <div v-for="(day, index) in dates" :key="index" class="d-flex align-center px-3 py-2 border-bottom">
                        <div class="flex-grow-1">
                          <div class="white--text text-body-2">{{ $moment(day.date).format("dd, DD.MM.YYYY") }}</div>
                          <div class="caption grey--text" v-if="day.vacationDay">
                            {{ day.vacationDay }}
                          </div>
                        </div>

                        <div v-if="!day.vacationDay">
                          <v-btn-toggle
                            v-model="day.isHalfDay"
                            mandatory
                            dense
                            rounded
                            borderless
                            background-color="rgba(255,255,255,0.05)"
                            @change="toggleHalfDay(day)">
                            <v-btn color="primary" :value="false" x-small width="60" class="white--text"> Ganzer </v-btn>
                            <v-btn color="primary" :value="true" x-small width="60" class="white--text"> Halber </v-btn>
                          </v-btn-toggle>
                        </div>
                        <div v-else>
                          <v-icon small color="grey">mdi-cancel</v-icon>
                        </div>
                      </div>
                    </div>
                  </v-card>

                  <v-card color="#333" class="rounded-lg pa-4 mb-4 elevation-0">
                    <div class="text-subtitle-2 white--text mb-2">Zusammenfassung</div>
                    <div class="d-flex justify-space-between mb-1">
                      <span class="grey--text caption">Zeitraum:</span>
                      <span class="white--text caption">{{ $moment(startDate).format("DD.MM.") }} - {{ $moment(endDate).format("DD.MM.YYYY") }}</span>
                    </div>
                    <div class="d-flex justify-space-between mb-1">
                      <span class="grey--text caption">Dauer (Tage):</span>
                      <span class="white--text caption font-weight-bold">{{ getDuration() }}</span>
                    </div>
                    <div class="d-flex justify-space-between mb-1">
                      <span class="grey--text caption">Saldo nach Abzug:</span>
                      <span
                        class="white--text caption font-weight-bold"
                        :class="vacations.days - getDuration(true) < 0 ? 'red--text' : 'success--text'">
                        {{ Math.round((vacations.days - getDuration(true)) * 100) / 100 }}
                      </span>
                    </div>
                  </v-card>

                  <v-expand-transition>
                    <v-alert
                      v-if="overlapInfo && overlapInfo.count > 0"
                      color="rgba(255, 152, 0, 0.12)"
                      class="rounded-lg mb-4 pa-3"
                      style="border: 1px solid rgba(255, 152, 0, 0.4)"
                      dense>
                      <div class="d-flex align-start">
                        <v-icon color="orange" small class="mt-1 mr-2">mdi-account-group-outline</v-icon>
                        <div>
                          <div class="orange--text caption font-weight-bold mb-1">
                            {{ overlapInfo.count }} Kolleg{{ overlapInfo.count === 1 ? "e hat" : "en haben" }} in diesem Zeitraum ebenfalls Ferien
                            beantragt.
                          </div>
                          <div class="grey--text" style="font-size: 11px; line-height: 1.4">
                            Du kannst trotzdem buchen, jedoch muss die Centerleitung zustimmen und könnte den Antrag ablehnen.
                          </div>
                          <div v-if="overlapInfo.datesWithOverlap && overlapInfo.datesWithOverlap.length" class="mt-2">
                            <div v-for="d in overlapInfo.datesWithOverlap" :key="d.date" class="d-flex align-center mb-1">
                              <v-icon x-small color="orange darken-2" class="mr-1">mdi-calendar-alert</v-icon>
                              <span class="orange--text text--darken-2" style="font-size: 11px">
                                {{ $moment(d.date).format("dd, DD.MM.YYYY") }}:
                              </span>
                              <span class="grey--text text--lighten-1 ml-1" style="font-size: 11px">
                                {{ d.count }} {{ d.count === 1 ? "Person" : "Personen" }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-alert>
                  </v-expand-transition>
                  <v-progress-linear v-if="overlapLoading" indeterminate color="orange" rounded height="2" class="mb-4"></v-progress-linear>

                  <v-textarea
                    v-model="reason"
                    placeholder="Bemerkung (Optional)"
                    solo
                    flat
                    background-color="#333"
                    dark
                    rounded
                    rows="2"
                    hide-details
                    class="mb-4"></v-textarea>

                  <div class="d-flex">
                    <v-btn
                      text
                      color="grey"
                      @click="
                        stepperModel -= 1
                        dates = []
                      "
                      >Zurück</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn :loading="!buttonEnabled" color="#00963f" depressed class="rounded-lg white--text px-6" @click="saveHolidayEntry">
                      Beantragen
                    </v-btn>
                  </div>
                </v-stepper-content>
              </v-stepper>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api"
import { mapState } from "vuex"
export default {
  name: "EnterHolidays",
  data() {
    return {
      buttonEnabled: true,
      holidayEntries: [],
      holidaysData: [],
      overlapInfo: null,
      overlapLoading: false,
      mapHolidayStatus: {
        open: "Offen",
        accepted: "Akzeptiert",
        rejected: "Abgelehnt",
      },
      tab: null,
      stepperModel: 1,
      startDate: this.$moment().format("YYYY-MM-DD"),
      endDate: this.$moment().add(1, "days").format("YYYY-MM-DD"),
      dialog: false,
      vacations: { percentage: 100, days: 0, hours: 0, pensumHistory: [] },
      dates: [],
      reason: "",
    }
  },
  async created() {
    this.holidayEntries = await api.fetchHolidayEntryEmployee()
    let rawVacations = await api.fetchVacationDaysLeft()
    this.normalizeVacationsData(rawVacations)
    if (api.fetchHolidays) {
      try {
        this.holidaysData = await api.fetchHolidays()
      } catch (e) {
        console.error("Error fetching holidays", e)
      }
    }
  },
  methods: {
    // Diese Funktion fängt fehlende Daten ab und verhindert NaN
    normalizeVacationsData(raw) {
      if (!raw) raw = {}

      // 1. Pensum absichern (Falls 0 oder undefined -> Fallback auf 100)
      let pct = raw.currentPercentage || raw.timeTrackerPercentage || 100
      if (pct === 0) pct = 100

      // 2. Stunden absichern (egal wie das Backend die Felder nennt)
      let hrs = 0
      if (raw.hours !== undefined && raw.hours !== null) hrs = raw.hours
      else if (raw.vacationHoursLeft !== undefined && raw.vacationHoursLeft !== null) hrs = raw.vacationHoursLeft

      if (isNaN(hrs)) hrs = 0

      // 3. Tage absichern (Falls das Backend keine Tage liefert, errechnen wir sie)
      let calculatedDays = hrs / (8.4 * (pct / 100))
      let d = raw.days !== undefined && raw.days !== null ? raw.days : calculatedDays

      if (isNaN(d)) d = 0

      this.vacations = {
        ...raw,
        percentage: pct,
        hours: hrs,
        days: d,
        pensumHistory: raw.pensumHistory || [],
      }
    },

    getPercentageForDate(targetDate) {
      const targetMonth = this.$moment(targetDate).format("YYYY-MM")
      let history = this.vacations.pensumHistory || []

      if (history.length > 0) {
        // String localeCompare ist robuster für 'YYYY-MM' Formate
        let sortedHistory = [...history].sort((a, b) => {
          let dateA = a.validFrom || "1970-01"
          let dateB = b.validFrom || "1970-01"
          return dateB.localeCompare(dateA)
        })

        for (let h of sortedHistory) {
          if (h.validFrom && targetMonth >= h.validFrom) {
            return h.percentage || this.vacations.percentage
          }
        }
      }
      return this.vacations.percentage
    },

    getDuration(filter = false) {
      return this.dates.filter((date) => (filter ? !date.vacationDay : true)).reduce((acc, date) => acc + date.dayFraction, 0)
    },

    toggleHalfDay(dayItem) {
      if (dayItem.vacationDay) return

      let pct = dayItem.percentage || this.vacations.percentage
      let hoursForThisDay = Math.round(8.4 * (pct / 100) * 1000) / 1000

      if (dayItem.isHalfDay === true) {
        dayItem.duration = hoursForThisDay / 2
        dayItem.dayFraction = 0.5
      } else {
        dayItem.duration = hoursForThisDay
        dayItem.dayFraction = 1
      }
    },

    resolveHolidayCode() {
      let studioId = this.vacations.resolvedStudioId || this.vacations.studio || this.vacations.team
      if (!studioId) return "TG-FF-FF"

      // 1. Try direct studio lookup
      let fullStudio = this.storeStudios.find((std) => std._id && std._id.toString() === studioId.toString())
      if (fullStudio && fullStudio.holidayCode) return fullStudio.holidayCode

      // 2. If studioId is a team (or not found), try using vacations.studio
      if (this.vacations.studio && this.vacations.studio.toString() !== studioId.toString()) {
        let linkedStudio = this.storeStudios.find((std) => std._id && std._id.toString() === this.vacations.studio.toString())
        if (linkedStudio && linkedStudio.holidayCode) return linkedStudio.holidayCode
      }

      // 3. Fallback
      return "TG-FF-FF"
    },

    isPublicHoliday(dateStr) {
      if (!this.holidaysData || !this.holidaysData.length) return null
      let holidayCode = this.resolveHolidayCode()

      let match = this.holidaysData.find((holiday) => {
        let start = holiday.startDate && holiday.startDate.$date ? holiday.startDate.$date : holiday.startDate
        if (!start) return false
        if (this.$moment(start).format("YYYY-MM-DD") !== dateStr) return false

        if (holiday.nationwide) return true
        if (holidayCode && holiday.type === "Public" && holiday.cantons && holiday.cantons.some((c) => holidayCode.startsWith(c))) {
          return true
        }
        return false
      })

      return match ? match.name || true : null
    },

    async calculateDates() {
      let start = this.$moment(this.startDate)
      let end = this.$moment(this.endDate)
      this.dates = []
      let vacationDays = []

      if (this.storeStudios && this.storeStudios.length > 0) {
        let s = this.storeStudios.find((std) => {
          if (!std._id) return false
          const stdIdStr = std._id.toString()
          if (this.vacations.studio && this.vacations.studio.toString() === stdIdStr) return true
          if (this.vacations.team && this.vacations.team.toString() === stdIdStr) return true
          if (this.vacations.resolvedStudioId && this.vacations.resolvedStudioId.toString() === stdIdStr) return true
          return false
        })
        if (s && s.vacationDays) {
          // Deduplicate custom vacation days by date
          const seenCustom = new Set()
          for (const d of s.vacationDays) {
            if (d && d.date && !seenCustom.has(d.date)) {
              seenCustom.add(d.date)
              vacationDays.push(d)
            }
          }
        }
      }

      while (start <= end) {
        let currentStr = this.$moment(start).format("YYYY-MM-DD")
        let vacDay = vacationDays.find((d) => d.date === currentStr)
        let isWeekend = this.$moment(start).weekday() === 5 || this.$moment(start).weekday() === 6

        // Check for public holidays from API (nationwide + cantonal)
        let publicHoliday = !isWeekend && !vacDay ? this.isPublicHoliday(currentStr) : null

        let pct = this.getPercentageForDate(currentStr)
        let hoursForDay = Math.round(8.4 * (pct / 100) * 1000) / 1000

        let isNonWorkDay = vacDay || isWeekend || publicHoliday
        let vacationDayLabel = vacDay ? vacDay.title || true : isWeekend ? this.$moment(start).format("dddd") : publicHoliday ? publicHoliday : false

        this.dates.push({
          date: currentStr,
          vacationDay: vacationDayLabel,
          duration: isNonWorkDay ? 0 : hoursForDay,
          dayFraction: isNonWorkDay ? 0 : 1,
          percentage: pct,
          isHalfDay: false,
        })
        start = this.$moment(start).add(1, "days")
      }
      this.stepperModel = 3

      this.overlapInfo = null
      this.overlapLoading = true
      try {
        this.overlapInfo = await api.fetchHolidayOverlap(this.startDate, this.endDate)
      } catch (e) {
        this.overlapInfo = null
      } finally {
        this.overlapLoading = false
      }
    },

    async selfCancelHoliday(id) {
      if (!confirm("Antrag wirklich zurückziehen?")) return
      try {
        await api.changeHolidayStatus({ _id: id, status: "rejected" })
        this.$toast.success("Antrag zurückgezogen")

        this.holidayEntries = await api.fetchHolidayEntryEmployee()
        let rawVacations = await api.fetchVacationDaysLeft()
        this.normalizeVacationsData(rawVacations)

        this.$emit("fetchEntries")
      } catch (e) {
        this.$toast.error("Fehler beim Abbrechen")
      }
    },

    async saveHolidayEntry() {
      this.buttonEnabled = false

      // Warnung anzeigen, aber NICHT blockieren (Darf ins Minus gehen!)
      if (this.getDuration(true) > this.vacations.days) {
        if (this.$toast.info) {
          this.$toast.info("Hinweis: Dein Feriensaldo geht ins Minus.")
        }
      }

      try {
        let exactSubtractedHours = this.dates.filter((d) => !d.vacationDay).reduce((acc, d) => acc + d.duration, 0)

        let newEntry = {
          vacationDays: this.dates,
          status: "open",
          duration: this.getDuration(),
          subtractedDays: this.getDuration(true),
          vacationDaysLeft: this.vacations.days - this.getDuration(true),
          subtractedVacationHours: Math.round(exactSubtractedHours * 100) / 100,
          reason: this.reason,
        }

        await api.createHolidayEntryEmployee(newEntry)
        this.$toast.success("Ferien beantragt")
        this.$emit("fetchEntries")

        this.tab = 0
        this.startDate = this.$moment().format("YYYY-MM-DD")
        this.endDate = this.$moment().add(1, "days").format("YYYY-MM-DD")
        this.reason = ""
        this.stepperModel = 1
        this.dates = []

        let rawVacations = await api.fetchVacationDaysLeft()
        this.normalizeVacationsData(rawVacations)
        this.holidayEntries = await api.fetchHolidayEntryEmployee()
      } catch (e) {
        this.$toast.error("Fehler beim Speichern")
      } finally {
        this.buttonEnabled = true
      }
    },
  },
  computed: {
    ...mapState("studioStore", ["storeStudios"]),
    sortedHolidayEntries() {
      const entries = [...this.holidayEntries]
      return entries.sort((a, b) => {
        const dateA = a.dates && a.dates.length ? new Date(a.dates[0].date) : new Date()
        const dateB = b.dates && b.dates.length ? new Date(b.dates[0].date) : new Date()
        return dateB - dateA
      })
    },
  },
}
</script>

<style scoped>
.gradient-dark {
  background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
}
.border-light {
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.border-bottom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.transparent-bg {
  background: transparent !important;
}
.v-btn-toggle .v-btn.v-btn--active {
  font-weight: bold;
}
::v-deep .v-stepper__wrapper {
  overflow: auto !important;
}
</style>
